<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex';
import { EventBus, EVENTS } from '../libs/eventBus';

const clearTimer = (reference) => {
  // try to clear current interval, if there is one
  try {
    clearInterval(reference);
  } catch (e) {
  }
};

  export default {
    name: 'SyncService',
    data: () => ({
      intervalReference: null,
    }),
    computed: {
      ...mapState([
        'user',
        'observations',
        'assessments',
      ]),
    },
    mounted() {
      const self = this;

      EventBus.$on(EVENTS.RESTART_SYNC, () => {
        clearTimer(self.intervalReference);

        self.intervalReference = setInterval( () => {
          //businessLogicObservation.syncAllObservations();
          // todo: Sync assessments
          EventBus.$emit(EVENTS.STOP_SYNC);
        }, 3000);

      });

      EventBus.$on(EVENTS.STOP_SYNC, () => {
        clearTimer(self.intervalReference);
      });

      EventBus.$on(EVENTS.IMMEDIATE_SYNC, () => {
        clearTimer(self.intervalReference);
      });
    }
  };
</script>

<style scoped>

</style>
